import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { EntityName } from '@/components';

const StyledKpiEntityName = styled(EntityName)`
  ${(props) => css`
    font-size: ${props.theme.sizes['1']};
    color: ${props.theme.colors.text};
  `}
`;

const KpiEntityName = ({ symbol1, symbol2, children }) => {
  return (
    <StyledKpiEntityName symbol1={symbol1} symbol2={symbol2}>
      {children}
    </StyledKpiEntityName>
  );
};

KpiEntityName.propTypes = {
  symbol1: PropTypes.node,
  symbol2: PropTypes.node,
  children: PropTypes.node
};

export default KpiEntityName;
